import { Badge } from '@shared/ui/badge';

import { INVEST_STATUS_BADGE_LABEL } from '../config/investment.text';
import { INVEST_STATUS_BADGE_TONE, STATUS_BADGE_CLASS } from '../config/investment-badge.constant';
import type { InvestStatusBadgeType } from '../model/invest-status';

export interface InvestStatusBadgeProps {
  type: InvestStatusBadgeType;
}

/** 투자 상태 배지. None 은 `toInvestStatusBadgeType()` 이 null 을 주므로 부르는 쪽이 그리지 않는다 */
export function InvestStatusBadge({ type }: InvestStatusBadgeProps) {
  return (
    <Badge
      tone={INVEST_STATUS_BADGE_TONE[type]}
      appearance="solid"
      size="sm"
      data-type={type}
      className={STATUS_BADGE_CLASS[type]}
    >
      {INVEST_STATUS_BADGE_LABEL[type]}
    </Badge>
  );
}
